var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"id":"dashboard-core-footer"}},[_c('v-container',[_c('v-row',{attrs:{"align":"center","no-gutters":""}},[_c('v-spacer',{staticClass:"hidden-sm-and-down"})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }